import React, { useRef, useState, useEffect } from "react";
import { Card } from "../../../../shadcn/components/ui/card";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../../shadcn/components/ui/tabs";
import { getAllBlogs, getOnlyCategories } from "services";
import { getAllArticleByCategory } from "services/blogs/index";
import { BlogsMenuCard } from "../../../../shadcn/components/custom/BlogsMenuCard";
import { DateTime } from "luxon";

interface BlogsData {
  date?: string;
  title?: string;
  description?: string;
  imageLink?: string;
  link?: string;
  category?: string;
}
export function BlogsMenu() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [blogsData, setBlogsData] = useState<BlogsData[]>([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allBlogs, setAllBlogs] = useState<any>([]);
  const [category, setCategory] = useState("all");

  const init = async () => {
    const allLatestPosts: any = await getAllBlogs();
    const temp: any = await getOnlyCategories();
    setAllCategories(temp?.data);
    const filteredData =
      [...(allLatestPosts?.data || [])].map((blog: any, index: number) => ({
        date: DateTime.fromISO(blog.attributes.publishedAt)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMM yyyy"),
        title: blog.attributes.title.split(" ").slice(0, 10).join(" "),
        description: blog.attributes.description
          .split(" ")
          .slice(0, 10)
          .join(" "),
        imageLink: blog.attributes.image.data.attributes.url,
        link: `/blogs/${blog.attributes.slug}`,
        category: blog.attributes.category.data.attributes.name,
      })) || [];
    setAllBlogs(filteredData);
    setBlogsData(filteredData);
  };

  useEffect(() => {
    (async () => {
      await init();
    })();
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateScrollPosition = () => {
      const scrollPercentage =
        2.3 *
        (scrollContainer.scrollLeft /
          (scrollContainer.scrollWidth - scrollContainer.clientWidth)) *
        100;
      scrollContainer.style.setProperty(
        "--scroll-position",
        `${scrollPercentage}%`
      );
    };

    scrollContainer.addEventListener("scroll", updateScrollPosition);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollPosition);
  }, []);

  useEffect(() => {
    (async () => {
      if (category === "all") {
        setBlogsData(allBlogs || []);
      } else {
        const temp: any = await getAllArticleByCategory(category, 1);
        const allPostsByCategory =
          temp.data?.map((blog: any, index: number) => ({
            date: DateTime.fromISO(blog.attributes.publishedAt)
              .setZone("Asia/Kolkata")
              .toFormat("dd MMM yyyy"),
            title: blog.attributes.title.split(" ").slice(0, 10).join(" "),
            description: blog.attributes.description
              .split(" ")
              .slice(0, 10)
              .join(" "),
            imageLink: blog.attributes.image.data.attributes.url,
            link: `/blogs/${blog.attributes.slug}`,
            category: blog.attributes.category.data.attributes.name,
          })) || [];

        setBlogsData(allPostsByCategory || []);
      }
    })();
  }, [category]);

  return (
    <div className="px-customPaddingMobile pt-7 lg:pt-0 lg:px-customPadding mt-4 lg:mt-12 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
      <Tabs defaultValue="all" className="w-full">
        <div className="overflow-auto scrollbar-hide">
          <TabsList className="w-[613px] lg:w-full  gap-[56px] lg:flex lg:justify-between bg-white  font-openSans font-normal text-web-body-md lg:text-web-body-lg leading-4 text-[#A8A8A8]">
            <TabsTrigger
              onClick={async () => {
                setCategory("all");
              }}
              value="all"
              key={`blogs_all`}
            >
              All
            </TabsTrigger>
            {allCategories.map((item: any) => (
              <TabsTrigger
                className="capitalize"
                onClick={async () => {
                  setCategory(item?.attributes?.slug);
                }}
                value={item?.attributes?.slug}
                key={`blogs_${item?.attributes?.slug}`}
              >
                {item?.attributes?.name}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>

        {/* Cards are here */}
        <TabsContent className="mt-6 lg:mt-9" value={"all"} key={`all`}>
          <Card className="border-none shadow-none relative">
            <div
              ref={scrollContainerRef}
              className="pb-1 space-y-11 lg:space-y-0 lg:grid lg:grid-cols-3 gap-6 lg:gap-y-[60px]"
            >
              {blogsData?.map((card, index) => (
                <div
                  key={`blog_card_${card?.category}_${index}`}
                  className="bg-white w-full min-w-[320px] lg:min-w-0 hover:shadow-sm hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out"
                >
                  <BlogsMenuCard
                    textContent={card?.description}
                    tag={card?.category}
                    blogDate={card?.date}
                    imageLink={card?.imageLink}
                    blogLink={card?.link}
                  />
                </div>
              ))}
            </div>
          </Card>
        </TabsContent>

        {allCategories?.map((item: any) => (
          <TabsContent
            className="mt-6 lg:mt-9"
            value={item?.attributes?.slug}
            key={`blogs_${item?.attributes?.slug}`}
          >
            <Card className="border-none shadow-none relative">
              <div
                ref={scrollContainerRef}
                className="pb-1 space-y-11 lg:space-y-0 lg:grid lg:grid-cols-3 gap-6 lg:gap-y-[60px]"
              >
                {blogsData?.map((card, index) => (
                  <div
                    key={`blog_card_${card?.category}_${index}`}
                    className="bg-white w-full min-w-[320px] lg:min-w-0 hover:shadow-sm hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out"
                  >
                    <BlogsMenuCard
                      textContent={card?.description}
                      tag={card?.category}
                      blogDate={card?.date}
                      imageLink={card?.imageLink}
                      blogLink={card?.link}
                    />
                  </div>
                ))}
              </div>
            </Card>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
